import { render, staticRenderFns } from "./ContactInformation.vue?vue&type=template&id=1c3bba1b&scoped=true&"
import script from "./ContactInformation.vue?vue&type=script&lang=js&"
export * from "./ContactInformation.vue?vue&type=script&lang=js&"
import style0 from "./ContactInformation.vue?vue&type=style&index=0&id=1c3bba1b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3bba1b",
  null
  
)

export default component.exports